import { NgModule, Provider } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { CommunityNotificationsService } from '../services/community-notifications.service';
import { NotificationBellComponent } from './notification-bell/notification-bell.component';
import { NotificationPanelComponent } from './notification-panel/notification-panel.component';
import { NotificationRowComponent } from './notification-row/notification-row.component';
import { PushApi } from './push-api';
import { WebPushService } from './web-push.service';

/**
 * WebPushService has to be one instance for the session, and this is what makes that true.
 *
 * These belong to the importer rather than to the module below, because that module is imported by both the
 * eager LayoutModule and the lazy KnowledgeModule. Listed as its providers, each injector would build its own
 * WebPushService, only the bell's would ever be probed, and the page's toggle would sit in `probing` forever
 * and never render. LayoutModule is eager, so registering them there puts one instance in the root injector
 * that the lazy injector resolves through.
 */
export const KNOWLEDGE_NOTIFICATION_PROVIDERS: Provider[] = [CommunityNotificationsService, PushApi, WebPushService];

/**
 * The bell, its drawer and the row both the drawer and the page render. Declarations only.
 *
 * It deliberately does not import CommunityServicesModule: that would hoist all thirteen Community providers
 * into the root injector and pull thirteen service files into the first-paint bundle to reach one of them.
 */
@NgModule({
  declarations: [NotificationBellComponent, NotificationPanelComponent, NotificationRowComponent],
  imports: [SharedModule],
  exports: [NotificationBellComponent, NotificationRowComponent],
})
export class KnowledgeNotificationsModule {}
